<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Listado de Huéspedes</h3>
      </div>

      <!-- Filtros y Búsqueda -->
      <div class="card mb-4 p-3 bg-light">
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label"><i class="bi bi-search me-2"></i>Buscar por Nombre</label>
            <input
              v-model="busquedaNombre"
              type="text"
              class="form-control"
              placeholder="Nombre o Apellido..."
            />
          </div>
          <div class="col-md-4">
            <label class="form-label"><i class="bi bi-telephone me-2"></i>Buscar por Teléfono</label>
            <input
              v-model="busquedaTelefono"
              type="text"
              class="form-control"
              placeholder="Teléfono..."
            />
          </div>
          <div class="col-md-4">
            <label class="form-label"><i class="bi bi-funnel me-2"></i>Filtrar por Tipo</label>
            <select
              v-model="filtroTipo"
              class="form-select"
            >
              <option value="">Todos los tipos</option>
              <option v-for="tipo in tiposHuesped" :key="tipo.IdTipoHuesped" :value="tipo.IdTipoHuesped">
                {{ tipo.Nombre }}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button class="btn btn-outline-secondary btn-sm" @click="limpiarFiltros">
              <i class="bi bi-arrow-counterclockwise me-1"></i>Limpiar Filtros
            </button>
            <span class="texto-resultados ms-3 text-muted">
              Mostrando {{ huespedesFiltrados.length }} de {{ huespedes.length }} huéspedes
            </span>
          </div>
        </div>
      </div>

      <!-- Tabla de Huéspedes -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Empresa</th>
              <th>NIT</th>
              <th>Teléfono</th>
              <th>DPI</th>
              <th>Placas</th>
              <th>Correo</th>
              <th>Tipo de Huésped</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="huespedesFiltrados.length === 0">
              <td colspan="10" class="text-muted">No hay huéspedes que coincidan con los filtros.</td>
            </tr>
            <tr v-for="h in huespedesFiltrados" :key="h.IdHuesped">
              <td>{{ h.Nombre }}</td>
              <td>{{ h.Apellido }}</td>
              <td>{{ h.Empresa }}</td>
              <td>{{ h.NIT || '---' }}</td>
              <td>{{ h.Telefono }}</td>
              <td>{{ h.DPI || '---' }}</td>
              <td>{{ h.Placas || '---' }}</td>
              <td>{{ h.Correo || '---' }}</td>
              <td>{{ h.tipo?.Tipo + ' - ' + h.tipo?.Nombre }}</td>
              <td>
                <button
                  class="btn btn-sm btn-warning me-2"
                  @click="abrirModalEdicion(h)"
                  title="Editar huésped">
                  <i class="bi bi-pencil-square"></i> Editar
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  @click="abrirModalConfirmacionEliminar(h)"
                  title="Eliminar huésped">
                  <i class="bi bi-trash-fill"></i> Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Editar Huésped -->
    <div
      v-if="modalEdicionVisible"
      class="modal fade show d-block"
      tabindex="-1"
      role="dialog"
      style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content bg-white shadow">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-pencil-square me-2"></i>Editar Huésped</h5>
            <button type="button" class="btn-close" @click="cerrarModalEdicion"></button>
          </div>

          <div class="modal-body">
            <form @submit.prevent="guardarCambiosHuesped">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Nombre <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.Nombre"
                    required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Apellido <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.Apellido"
                    required />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Teléfono <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.Telefono"
                    placeholder="8 dígitos o con prefijo 502"
                    required />
                  <small class="text-muted">Ej: 12345678 o 50212345678</small>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Empresa</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.Empresa" />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">NIT</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.NIT" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">DPI</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.DPI" />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Placas Vehículo</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="huespedEdicion.Placas" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Correo <span class="text-muted">(Opcional)</span></label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="huespedEdicion.Correo"
                    placeholder="correo@ejemplo.com" />
                  <small
                    v-if="huespedEdicion.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(huespedEdicion.Correo)"
                    class="text-danger">
                    <i class="bi bi-exclamation-triangle-fill"></i> Correo inválido — se omitirá en la factura FEL
                  </small>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Tipo de Huésped</label>
                  <select class="form-select" v-model="huespedEdicion.IdTipoHuesped">
                    <option v-for="tipo in tiposHuesped" :key="tipo.IdTipoHuesped" :value="tipo.IdTipoHuesped">
                      {{ tipo.Tipo + ' - ' + tipo.Nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cerrarModalEdicion">
              <i class="bi bi-x-circle me-1"></i>Cancelar
            </button>
            <button type="button" class="btn btn-success" @click="guardarCambiosHuesped">
              <i class="bi bi-check-circle me-1"></i>Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Confirmación Eliminar Huésped -->
    <div
      v-if="modalConfirmacionVisible"
      class="modal fade show d-block"
      tabindex="-1"
      role="dialog"
      style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white shadow">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title"><i class="bi bi-exclamation-triangle me-2"></i>Confirmar Eliminación</h5>
            <button type="button" class="btn-close btn-close-white" @click="cerrarModalConfirmacion"></button>
          </div>

          <div class="modal-body">
            <p v-if="huespedAEliminar" class="mb-0">
              ¿Está seguro que desea eliminar al huésped <strong>{{ huespedAEliminar.Nombre }} {{ huespedAEliminar.Apellido }}</strong>?
            </p>
            <p class="text-danger small mt-2 mb-0">
              <i class="bi bi-exclamation-circle me-1"></i>
              Esta acción no se puede deshacer.
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cerrarModalConfirmacion">
              <i class="bi bi-x-circle me-1"></i>Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="eliminarHuesped"
              :disabled="cargandoEliminacion">
              <i class="bi bi-trash-fill me-1"></i>{{ cargandoEliminacion ? 'Eliminando...' : 'Eliminar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "ListadoHuespedes",
  data() {
    return {
      huespedes: [],
      tiposHuesped: [],
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      busquedaNombre: "",
      busquedaTelefono: "",
      filtroTipo: "",
      modalEdicionVisible: false,
      huespedEdicion: {
        IdHuesped: null,
        Nombre: "",
        Apellido: "",
        Empresa: "",
        NIT: "",
        Telefono: "",
        DPI: "",
        Placas: "",
        Correo: "",
        IdTipoHuesped: 1
      },
      cargandoEdicion: false,
      modalConfirmacionVisible: false,
      huespedAEliminar: null,
      cargandoEliminacion: false
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    huespedesFiltrados() {
      return this.huespedes.filter(h => {
        // Búsqueda por nombre (nombre o apellido)
        const coincideNombre =
          (h.Nombre?.toLowerCase().includes(this.busquedaNombre.toLowerCase()) ||
          h.Apellido?.toLowerCase().includes(this.busquedaNombre.toLowerCase()));

        // Búsqueda por teléfono
        const coincideTelefono =
          h.Telefono?.includes(this.busquedaTelefono);

        // Filtro por tipo
        const coincideTipo =
          this.filtroTipo === "" || h.IdTipoHuesped === parseInt(this.filtroTipo);

        return coincideNombre && coincideTelefono && coincideTipo;
      });
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerHuespedes() {
      try {
        const res = await axios.get(`${API_URL}/huesped`);
        this.huespedes = res.data;
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al cargar huéspedes", "danger");
      }
    },
    async obtenerTiposHuesped() {
      try {
        const res = await axios.get(`${API_URL}/tipos-huesped`);
        this.tiposHuesped = res.data;
      } catch (error) {
        console.error(error);
      }
    },
    limpiarFiltros() {
      this.busquedaNombre = "";
      this.busquedaTelefono = "";
      this.filtroTipo = "";
    },
    abrirModalEdicion(huesped) {
      // Copiar datos del huésped para edición
      this.huespedEdicion = {
        IdHuesped: huesped.IdHuesped,
        Nombre: huesped.Nombre,
        Apellido: huesped.Apellido,
        Empresa: huesped.Empresa,
        NIT: huesped.NIT,
        Telefono: huesped.Telefono,
        DPI: huesped.DPI,
        Placas: huesped.Placas,
        Correo: huesped.Correo,
        IdTipoHuesped: huesped.IdTipoHuesped
      };
      this.modalEdicionVisible = true;
    },
    cerrarModalEdicion() {
      this.modalEdicionVisible = false;
      this.huespedEdicion = {
        IdHuesped: null,
        Nombre: "",
        Apellido: "",
        Empresa: "",
        NIT: "",
        Telefono: "",
        DPI: "",
        Placas: "",
        Correo: "",
        IdTipoHuesped: 1
      };
    },
    async guardarCambiosHuesped() {
      if (!this.huespedEdicion.Nombre || !this.huespedEdicion.Apellido || !this.huespedEdicion.Telefono) {
        this.mostrarAlerta("Nombre, Apellido y Teléfono son requeridos", "danger");
        return;
      }

      try {
        this.cargandoEdicion = true;
        const response = await axios.put(
          `${API_URL}/huesped/${this.huespedEdicion.IdHuesped}`,
          this.huespedEdicion
        );

        // Actualizar el huésped en la lista
        const indice = this.huespedes.findIndex(h => h.IdHuesped === this.huespedEdicion.IdHuesped);
        if (indice !== -1) {
          this.huespedes[indice] = response.data;
        }

        this.mostrarAlerta("Huésped actualizado correctamente", "success");
        this.cerrarModalEdicion();
      } catch (error) {
        console.error(error);
        const mensaje = error.response?.data?.message || "Error al actualizar huésped";
        this.mostrarAlerta(mensaje, "danger");
      } finally {
        this.cargandoEdicion = false;
      }
    },
    abrirModalConfirmacionEliminar(huesped) {
      this.huespedAEliminar = huesped;
      this.modalConfirmacionVisible = true;
    },
    cerrarModalConfirmacion() {
      this.modalConfirmacionVisible = false;
      this.huespedAEliminar = null;
    },
    async eliminarHuesped() {
      if (!this.huespedAEliminar) return;

      try {
        this.cargandoEliminacion = true;
        await axios.delete(`${API_URL}/huesped/${this.huespedAEliminar.IdHuesped}`);

        // Eliminar de la lista
        this.huespedes = this.huespedes.filter(h => h.IdHuesped !== this.huespedAEliminar.IdHuesped);

        this.mostrarAlerta(`Huésped ${this.huespedAEliminar.Nombre} ${this.huespedAEliminar.Apellido} eliminado correctamente`, "success");
        this.cerrarModalConfirmacion();
      } catch (error) {
        console.error(error);
        const mensaje = error.response?.data?.message || "Error al eliminar huésped";
        this.mostrarAlerta(mensaje, "danger");
      } finally {
        this.cargandoEliminacion = false;
      }
    }
  },
  mounted() {
    this.obtenerHuespedes();
    this.obtenerTiposHuesped();
  },
};
</script>